import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

/** Title, banner and the form sections while the event loads (P16). */
const EventFormSkeleton = () => (
  <Stack gap={3} sx={{ maxWidth: 880, mx: 'auto', width: '100%' }} aria-busy="true">
    <Skeleton variant="text" width="35%" height={40} />
    <Skeleton variant="rounded" height={260} />
    <Skeleton variant="rounded" height={180} />
    <Skeleton variant="rounded" height={220} />
  </Stack>
);

export default EventFormSkeleton;
